import React from 'react';

const About = () => (
  <section id="about" className="py-16 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 px-4">
    <div className="max-w-3xl mx-auto">
      <h2 className="text-3xl font-bold mb-4">About Me</h2>
      <p className="mb-4">
        I am an enthusiastic IT student with a strong passion for web development and software engineering. My academic background has equipped me with solid fundamentals in programming, and I am always eager to learn new technologies and grow in the IT field.
      </p>
      <p>
        I enjoy building modern web and mobile applications, collaborating with teams, and solving real-world problems through code. I am committed to continuous improvement and excited to contribute as an IT intern.
      </p>
    </div>
  </section>
);

export default About; 